var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33337V8.00004L9.66667 9.66671",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73609 3.73609L3.38254 3.38254L3.73609 3.73609ZM2.89184 4.58035L2.39185 4.58286C2.39322 4.85704 2.61515 5.07896 2.88933 5.08034L2.89184 4.58035ZM4.58636 5.08887C4.8625 5.09026 5.08748 4.86753 5.08887 4.59139C5.09026 4.31525 4.86753 4.09027 4.59139 4.08888L4.58636 5.08887ZM3.38331 2.8808C3.38192 2.60466 3.15694 2.38193 2.8808 2.38332C2.60466 2.38471 2.38193 2.60969 2.38332 2.88583L3.38331 2.8808ZM2.55107 7.18995C2.58857 6.91636 2.39719 6.66418 2.1236 6.62668C1.85002 6.58918 1.59783 6.78056 1.56033 7.05415L2.55107 7.18995ZM12.5748 3.42518C10.028 0.878386 5.91249 0.852595 3.38254 3.38254L4.08965 4.08965C6.22239 1.95691 9.70473 1.9693 11.8677 4.13229L12.5748 3.42518ZM3.42518 12.5748C5.97197 15.1216 10.0875 15.1474 12.6175 12.6175L11.9104 11.9104C9.77761 14.0431 6.29527 14.0307 4.13229 11.8677L3.42518 12.5748ZM12.6175 12.6175C15.1474 10.0875 15.1216 5.97197 12.5748 3.42518L11.8677 4.13229C14.0307 6.29527 14.0431 9.77762 11.9104 11.9104L12.6175 12.6175ZM3.38254 3.38254L2.53829 4.22679L3.24539 4.9339L4.08965 4.08965L3.38254 3.38254ZM2.88933 5.08034L4.58636 5.08887L4.59139 4.08888L2.89435 4.08035L2.88933 5.08034ZM3.39183 4.57783L3.38331 2.8808L2.38332 2.88583L2.39185 4.58286L3.39183 4.57783ZM1.56033 7.05415C1.29271 9.00661 1.91595 11.0656 3.42518 12.5748L4.13229 11.8677C2.8519 10.5873 2.32442 8.84348 2.55107 7.18995L1.56033 7.05415Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.a636f91baefe708777c7c60266e155ae.svg";
export { ForwardRef as ReactComponent };